import type { Interview } from '@/types/interview';
import type { ApiResponse } from '@/types/api';
import type { PageResponse } from '@/types/resource';
import { request } from '@/utils/request';

/**
 * 面试管理相关API服务
 */
export default {
  /**
   * 创建面试记录
   * @param interview 面试信息
   * @returns 创建结果
   */
  async createInterview(interview: Interview): Promise<ApiResponse<Interview>> {
    const response = await request.post('/interviews', interview);
    return response;
  },

  /**
   * 更新面试记录
   * @param interview 面试信息
   * @returns 更新结果
   */
  async updateInterview(interview: Partial<Interview> & { id: number }): Promise<ApiResponse<Interview>> {
    const response = await request.put(`/interviews/${interview.id}`, interview);
    return response;
  },

  /**
   * 删除面试记录
   * @param id 面试ID
   * @returns 删除结果
   */
  async deleteInterview(id: number): Promise<ApiResponse<null>> {
    const response = await request.delete(`/interviews/${id}`);
    return response;
  },

  /**
   * 获取面试记录详情
   * @param id 面试ID
   * @returns 面试详情
   */
  async getInterviewById(id: number): Promise<ApiResponse<Interview>> {
    const response = await request.get(`/interviews/${id}`);
    return response;
  },

  /**
   * 获取职位相关的面试记录
   * @param positionId 职位ID
   * @returns 面试记录列表
   */
  async getInterviewsByPosition(positionId: number): Promise<ApiResponse<PageResponse<Interview>>> {
    console.log('Fetching interviews for position:', positionId);
    const response = await request.get(`/interviews/position/${positionId}`);
    return response;
  }
}; 